export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "About Us",
  headLine: "Creative Website design is our passion",
  description:
    "Nim Agency produces high-end solutions at affordable and market-competitive rates in website development, web design and SEO services. ",
  buttonLabel: "Read More",
  imgStart: false,
  img: require("../../images/svg-1.svg"),
  alt: "Web Design",
  dark: true,
  primary: true,
  darkText: false,
  pageUrl: "start",
};

export const homeObjTwo = {
  id: "portfolio",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Our Capabilities",
  headLine: "Helping you create your Digital Success Story",
  description:
    "Our team comprises inventive and creative developers and designers. When it comes to website development, our webpage designers create engaging website designs with the overall look and feel and color schemes, precisely as you want. We are a full-fledged digital agency that helps businesses achieve measurable results in all our focus areas.",
  buttonLabel: "Check our portfolio",
  imgStart: true,
  img: require("../../images/svg-2.svg"),
  alt: "Web Developemnt Agency",
  dark: true,
  primary: true,
  darkText: true,
  pageUrl: "start",
};

export const homeObjThree = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Contact Us",
  headLine: "Not finding what you are looking for?",
  description:
    "If you have an idea for a project that involves Mobile Applications, Content Creation, Visual Idendity, Photography or Video production, you can tell us more and we can see how we can work together. We are always looking for ways of expanding our knolodge and work with the most amazing Freelance Creators.",
  buttonLabel: "Read More",
  imgStart: false,
  img: require("../../images/svg-1.svg"),
  alt: "Web Design",
  dark: true,
  primary: true,
  darkText: true,
  pageUrl: "start",
};
